import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "sign-in",
  class: "bglight position-relative padding"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-12 text-center wow fadeIn\" data-wow-delay=\"300ms\"><h2 class=\"heading bottom30 darkcolor font-light2\"><span class=\"font-normal\">Verifikasi</span> Akun <span class=\"divider-center\"></span></h2><div class=\"col-md-8 offset-md-2 heading_space\"><p></p></div></div>", 1)
const _hoisted_5 = { class: "col-lg-12 pl-lg-0 col-md-12 whitebox noshadow" }
const _hoisted_6 = { class: "widget logincontainer" }
const _hoisted_7 = {
  key: 0,
  class: "row"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 col-sm-12 text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/comp-3-unscreen.gif",
    alt: ""
  })
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 col-sm-12 text-center" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "darkcolor bottom30 text-center text-danger" }, " Link Tidak Valid ! "),
  /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, " Link yang anda gunakan tidak valid, Silahkan cek kembali email anda ")
], -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "row"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 col-sm-12 text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/success-2.gif",
    alt: ""
  })
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 col-sm-12 text-center" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "darkcolor bottom30 text-center text-success" }, " Selamat, Akun anda telah terverifikasi ! "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/login",
    class: "mx-4 btn btn-warning bg-custom fw-bold"
  }, [
    /*#__PURE__*/_createElementVNode("strong", null, " Login ")
  ])
], -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_overlay = _resolveComponent("b-overlay")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_b_overlay, {
            show: _ctx.loadingCard,
            rounded: "sm"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                (!_ctx.loadingCard && !_ctx.successRegister)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
                  : _createCommentVNode("", true),
                (!_ctx.loadingCard && _ctx.successRegister)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_14))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["show"])
        ])
      ])
    ])
  ]))
}